var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 634,
    viewBox: "0 0 1920 634",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter0_f_31_5745)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1750.5,
    cy: -93.5,
    rx: 340.5,
    ry: 342.5,
    fill: "#7534FF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter1_f_31_5745)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1181.5,
    cy: -11,
    rx: 166.5,
    ry: 168,
    fill: "#F249C8"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter2_f_31_5745)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 595,
    cy: -378,
    rx: 659,
    ry: 271,
    fill: "#E64545"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter3_f_31_5745)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 175,
    cy: -93.5,
    rx: 209,
    ry: 251.5,
    fill: "#0B63E5"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter4_f_31_5745)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 375,
    cy: -93.5,
    rx: 76,
    ry: 138.5,
    fill: "#9DC1F5"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter5_f_31_5745)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 722,
    cy: -39,
    rx: 240,
    ry: 111,
    fill: "#FFC759"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_31_5745",
    x: 1025,
    y: -821,
    width: 1451,
    height: 1455,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 192.5,
    result: "effect1_foregroundBlur_31_5745"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_31_5745",
    x: 630,
    y: -564,
    width: 1103,
    height: 1106,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 192.5,
    result: "effect1_foregroundBlur_31_5745"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_31_5745",
    x: -449,
    y: -1034,
    width: 2088,
    height: 1312,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 192.5,
    result: "effect1_foregroundBlur_31_5745"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_31_5745",
    x: -419,
    y: -730,
    width: 1188,
    height: 1273,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 192.5,
    result: "effect1_foregroundBlur_31_5745"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_31_5745",
    x: -86,
    y: -617,
    width: 922,
    height: 1047,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 192.5,
    result: "effect1_foregroundBlur_31_5745"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_31_5745",
    x: 97,
    y: -535,
    width: 1250,
    height: 992,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 192.5,
    result: "effect1_foregroundBlur_31_5745"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeader);
export default __webpack_public_path__ + "static/media/header.41123ab3df1a8ae767cbf55b30d5240b.svg";
export { ForwardRef as ReactComponent };